'use client';

import { useTranslations } from 'next-intl';

export function SkipLink() {
  const t = useTranslations('Navbar');

  return (
    <a href="#main" className="skip-link">
      {t('skipToContent')}
    </a>
  );
}
